module.exports = __webpack_public_path__ + "img/heart_9.edeee2ce.png";